@switch (viewState()) {
@case ('loading') {
<ng-container [ngTemplateOutlet]="skeletonCard" />
}
@case ('list') {
<div
  class="queued-jobs-scroll tw-flex tw-flex-col tw-gap-4 lg:tw-gap-3 tw-min-h-0 tw-overflow-y-auto"
>
  @for (job of jobs(); track job.id) {
  <app-queued-job-card [job]="job" />
  }
  @if (isLoadingMore()) {
  <ng-container [ngTemplateOutlet]="skeletonCard" />
  }
  @if (hasMore() && !isLoadingMore()) {
  <button
    type="button"
    (click)="loadMore()"
    class="tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-w-full tw-h-[37px] tw-px-3 tw-py-2 tw-rounded-md tw-border tw-border-blue-600 tw-text-sm tw-font-medium tw-font-inter tw-leading-normal tw-text-blue-600"
  >
    {{ seePreviousJobsLabel }}
  </button>
  }
</div>
}
@case ('error') {
<ng-container [ngTemplateOutlet]="errorBox" [ngTemplateOutletContext]="{ $implicit: errorMessage() }" />
}
@case ('empty') {
<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-w-full tw-py-8 tw-rounded-md">
  <span class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-rounded-lg tw-bg-gray-200" [innerHTML]="icons.empty | safe"></span>
  <p class="tw-text-sm tw-font-normal tw-font-inter tw-leading-normal tw-text-center tw-text-gray-700">{{ emptyStateMessage }}</p>
</div>
}
}

<ng-template #skeletonCard>
  <div role="status" aria-busy="true" class="tw-flex tw-flex-col tw-gap-2 tw-shrink-0 tw-p-3 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50">
    <span class="tw-sr-only">{{ loadingLabel }}</span>
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
      <ngx-skeleton-loader [theme]="skeletonTheme.title" />
      <ngx-skeleton-loader [theme]="skeletonTheme.meta" />
    </div>
    <div class="tw-flex tw-gap-2">
      <ngx-skeleton-loader [theme]="skeletonTheme.eventChip" />
      <ngx-skeleton-loader [theme]="skeletonTheme.personaChip" />
    </div>
  </div>
</ng-template>

<ng-template #errorBox let-message>
  <div role="alert" class="tw-flex tw-items-start tw-gap-1 tw-shrink-0 tw-p-3 tw-rounded-lg tw-border tw-border-red-300 tw-bg-red-50 tw-font-inter">
    <span class="tw-flex tw-shrink-0 tw-p-px tw-mt-[3px]" [innerHTML]="icons.failed | safe"></span>
    <p class="tw-text-xs tw-font-medium tw-leading-normal tw-text-red-600">{{ message }}</p>
  </div>
</ng-template>
